// extracted by mini-css-extract-plugin
export default {"row":"_4xXnYhKRErQaWUHmHJIydg==","title":"yM+P3OG97beyjNUee9DJxA==","content":"YxcsT7f+B-QWmtaOZilIAA=="};